import Person from '../../../components/svg/person'
import Chart from '../../../components/svg/chart'
import Lock from '../../../components/svg/lock'
import Umbrela from '../../../components/svg/umbrela'

export default function FeaturesSection() {
  return (
    <div className='root featuresSelection'>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Chart />
        <h3>In-depth Review</h3>
        <p>
          Always receive the true value for your vehicle by describing it using our in-depth
          workflows. Accepted by automotive professionals and consumers.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Lock fill='var(--primary-color)' />
        <h3>Safe and secure transactions</h3>
        <p>
          True peace of mind private sales. We manage the transaction so you never have to worry
          about losing your money or vehicle.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Person />
        <h3>Verified buyers and sellers</h3>
        <p>
          Users must be verified before buying or selling. Real people buying and selling real cars.
        </p>
      </div>
      <div className='feat flex flexDirectionColumn alignCenter'>
        <Umbrela fill='var(--primary-color)' />
        <h3>Protect your purchase</h3>
        <p>
          Buyers on privauto are protected with a 7 day no hassle return policy (some
          conditions apply).
        </p>
      </div>

      <style jsx>{`
        .root {
          display: grid;
          padding: 0 3.3rem;
          grid-template-columns: 1fr 1fr 1fr 1fr;
          grid-gap: 6.5rem;
          max-width: 192rem;
          margin: 0 auto;
          background-color: #212529;
          padding-top: 7rem;

          h3 {
            margin: 2.9rem 0 0.7rem;
            text-align: center;
            font-size: 3.2rem;
            line-height: 3.6rem;
            color: #fff;
          }

          p {
            text-align: center;
            font-size: 1.8rem;
            line-height: 2.3rem;
            color: #fff;
          }

          :global(.feat svg) {
            width: 8rem;
            height: 7.4rem;
          }
        }

        @media (max-width: 1536px) {
          .root {
            grid-gap: 5rem;
          }
        }

        @media (max-width: 1200px) {
          .root {
            grid-gap: 5rem;

            h3 {
              font-size: 2.8rem;
              line-height: 3rem;
            }

            p {
              font-size: 1.6rem;
            }
          }
        }

        @media (max-width: 1024px) {
          .root {
            grid-template-columns: 1fr 1fr;

            p {
              font-size: 1.4rem;
              line-height: 1.8rem;
            }

            h3 {
              font-size: 1.6rem;
              margin: 1.6rem 0 0;
            }

            :global(.feat svg) {
              width: 7.3rem;
              height: 6.7rem;
            }
          }
        }

        @media (max-width: 600px) {
          .root {
            grid-template-columns: 1fr;
            grid-gap: 4rem;

            p {
              font-size: 1.6rem;
            }

            h3 {
              font-size: 1.8rem;
            }
          }
        }

        .featuresSelection :global(svg) {
          opacity: 0.5;
        }

        .featuresSelection p {
          opacity: 0.7;
        }
      `}</style>
    </div>
  )
}
